import React, { Fragment } from "react";
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";
import { Link } from "react-router-dom";
import DataAnalytics from "./DataAnalytics";

const DataAnalyticssinglepage: React.FC = () => {
  return (
    <Fragment>
      <div className='about-page inner-page'>
        <div className="body_wrap o-clip">
          <Header/>
          <main>
            <PageTitle pageTitle="Data Analytics" pagesub="Data Analytics" />
            <DataAnalytics></DataAnalytics>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default DataAnalyticssinglepage;